module.exports = __webpack_public_path__ + "media/src/assets/fonts/Montserrat-ExtraBold-2bd71f20a86651553aae5d1e7d3383eb.otf";